import React, { useEffect, useState } from "react";
import styles from "../subscription/Subscription.module.css";
import InputText from "../../component/inputText/InputText";
import {
  getSettingsSubscription,
  postSettingsSubscription,
} from "../../api/HttpApis";
import { FaEye, FaEyeSlash } from "react-icons/fa";
import { showToast } from "../../utils/Toastify/Toastify";

function Settings() {
  const [formData, setFormData] = useState({
    roku_pay_api_key: "",
    amazon_iap_secret: "",
    google_play_billing_key: "",
  });
  const [visibleFields, setVisibleFields] = useState({
    roku_pay_api_key: false,
    amazon_iap_secret: false,
    google_play_billing_key: false,
  });
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const fetchSettings = async () => {
      try {
        setLoading(true);
        const response = await getSettingsSubscription();

        const config = response?.data;

        if (config) {
          setFormData({
            roku_pay_api_key: config.roku_pay_api_key || "",
            amazon_iap_secret: config.amazon_iap_secret || "",
            google_play_billing_key: config.google_play_billing_key || "",
          });
        }
        else {
          showToast("No configuration found.", "info");
        }
      } catch (error) {
        console.error("Failed to load settings:", error);
        showToast("Failed to load settings.", "error");
      } finally {
        setLoading(false);
      }
    };

    fetchSettings();
  }, []);

  const handleChange = (e) => {
    const { id, value } = e.target;

    setFormData((prev) => ({
      ...prev,
      [id]: value,
    }));
  };

  const toggleVisibility = (field) => {
    setVisibleFields((prev) => ({
      ...prev,
      [field]: !prev[field],
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      setLoading(true);
      const result = await postSettingsSubscription(formData);
      showToast(result.message || "Configuration updated successfully.", "success");
    } catch (error) {
      showToast("Failed to update configuration.", "error");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className={styles["tab-content"]}>
      <h2 className={styles["table-title"]}>API Configuration</h2>
      <p className={styles["table-subtitle"]}>
        Configure your subscription settings
      </p>

      <form onSubmit={handleSubmit}>
        {/* Roku */}
        <div className={styles["form-group"]}>
          <label htmlFor="roku_pay_api_key">Roku Pay API Key</label>
          <div className={styles["input-wrapper"]} style={{ position: "relative" }}>
            <InputText
              type={visibleFields.roku_pay_api_key ? "text" : "password"}
              id="roku_pay_api_key"
              value={formData.roku_pay_api_key}
              onChange={handleChange}
              placeholder="Enter Roku Pay API Key"
              className={styles["input-dark"]}
            />
            <span
              className={styles.eyeIconWrapper}
              onClick={() => toggleVisibility("roku_pay_api_key")}
            >
              {visibleFields.roku_pay_api_key ? <FaEyeSlash /> : <FaEye />}
            </span>
          </div>
        </div>

        {/* Amazon */}
        <div className={styles["form-group"]}>
          <label htmlFor="amazon_iap_secret">Amazon IAP Secret</label>
          <div className={styles["input-wrapper"]} style={{ position: "relative" }}>
            <InputText
              type={visibleFields.amazon_iap_secret ? "text" : "password"}
              id="amazon_iap_secret"
              value={formData.amazon_iap_secret}
              onChange={handleChange}
              placeholder="Enter Amazon IAP Secret"
              className={styles["input-dark"]}
            />
            <span
              className={styles.eyeIconWrapper}
              onClick={() => toggleVisibility("amazon_iap_secret")}
            >
              {visibleFields.amazon_iap_secret ? <FaEyeSlash /> : <FaEye />}
            </span>
          </div>
        </div>

        {/* Google Play */}
        <div className={styles["form-group"]}>
          <label htmlFor="google_play_billing_key">
            Google Play Billing Key
          </label>
          <div className={styles["input-wrapper"]} style={{ position: "relative" }}>
            <InputText
              type={visibleFields.google_play_billing_key ? "text" : "password"}
              id="google_play_billing_key"
              value={formData.google_play_billing_key}
              onChange={handleChange}
              placeholder="Enter Google Play Billing Key"
              className={styles["input-dark"]}
            />
            <span
              className={styles.eyeIconWrapper}
              onClick={() => toggleVisibility("google_play_billing_key")}
            >
              {visibleFields.google_play_billing_key ? <FaEyeSlash /> : <FaEye />}
            </span>
          </div>
        </div>

        <button type="submit" className={styles["save-btn"]} disabled={loading}>
          {loading ? "Saving..." : "Save Configuration"}
        </button>
      </form>

     
     
    </div>
  );
}

export default Settings;
